import Image from "next/image";
import dynamic from "next/dynamic";
const AccordionCRM = dynamic(() => import("./accordian"),{ssr: true});
import { toWebp } from "@/utils/common";

interface systemProps {
  isMobile?: boolean;
  data?: any;
}

const Methodologies: React.FC<systemProps> = ({ data }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-[100px] md:py-[83px] lg:mb-[80px] xl:mb-[100px] overflow-hidden">
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-start justify-start mx-auto">
          <div className="grid md:grid-cols-12 md:gap-[30px] items-center w-full mb-[40px]">
            <div className="sm:text-left xl:col-span-12 md:col-span-12">
              <h2 className="text-heading-1 font-bold text-primary-text text-center max-w-[1230px] mx-auto">
                {data?.Title}
              </h2>
              <p className="text-subtitle-2 font-regular mt-3 text-secondary-text max-w-[980px] mx-auto text-center">
                {data?.Subtitle}
              </p>
            </div>
          </div>
        </div>

        {data?.Methodology?.map((method: any, index: number) => (
          <div
            key={method.id || index}
            className="sm:px-[32px] px-[12px] py-[24px] sm:py-[40px] sm:mb-[24px] last:sm:mb-[0]     mx-auto relative last:pb-[0] border-t border-blue-50 
              before:content-[''] before:absolute before:top-0 before:left-[-1px] before:h-[213px] before:w-px before:bg-blue-50 
              after:content-[''] after:absolute after:top-0 after:right-[-1px] after:h-[213px] after:w-px after:bg-blue-50
              "
          >
            <div className="absolute top-0 left-0 w-full h-[1230px] z-0 bg-[linear-gradient(180deg,_#FFFFFF_3.64%,_#E6F3FD_133.26%)]">
              <div
                className="w-full h-full bg-no-repeat bg-center bg-cover "
                style={{ backgroundImage: 'url("/images/crm/bg-pttern.png")' }}
              ></div>
            </div>

            <div className="grid md:grid-cols-12 gap-6 md:gap-[30px] items-start w-full relative z-40 text-center md:text-left">
              <div className="sm:text-left xl:col-span-5 md:col-span-6 flex xl:items-start md:items-start sm:justify-start justify-center">
                <h3 className="sm:text-heading-3 text-heading-2 text-center font-bold text-primary-text sm:text-left mb-0 max-w-[348px]">
                  {method.Title}
                </h3>
              </div>
              <div className="sm:text-left xl:col-span-7 md:col-span-6 flex items-center justify-center relative z-10">
                <p className="ms-auto max-w-[576px] text-secondary-text text-subtitle-2">
                  {method.Subtitle}
                </p>
              </div>
            </div>

            {method?.images?.data?.attributes?.url && (
              <div className="mt-[48px] relative z-10">
                <Image
                  alt={method.Title}
                  src={toWebp(
                    `${baseUrl}${method?.images?.data?.attributes?.url}`,
                  )}
                  height={492}
                  width={1200}
                  className="w-full h-auto md:h-[492px] object-contain"
                />
              </div>
            )}

            <div className="mt-[40px]">
              <AccordionCRM
                items={[
                  {
                    title:
                      method.methodology_keypoints?.title || "Key Practices",
                    theme: "blue",
                    content:
                      method.methodology_keypoints?.statistics?.map(
                        (point: any) => ({
                          heading: point?.title || "",
                          text: point?.description || "",
                          image: point?.image?.data?.attributes?.url
                            ? toWebp(
                                `${baseUrl}${point.image.data.attributes.url}`,
                              )
                            : undefined,
                        }),
                      ) || [],
                  },
                  {
                    title:
                      method.methodology_services?.Title || "Core Benefits",
                    theme: "green",
                    content:
                      method.methodology_services?.Card?.map((card: any) => ({
                        heading: card?.title || "",
                        text: card?.text || "",
                        image: card?.image?.data?.attributes?.url
                          ? toWebp(
                              `${baseUrl}${card.image.data.attributes.url}`,
                            )
                          : undefined,
                      })) || [],
                  },
                ]}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Methodologies;
